/**=========================================================
 * Module: tm.js
 * Group Controller
 =========================================================*/
App.controller('TmController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$filter', 'toaster', 'ngDialog', '$interval',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $filter, toaster, ngDialog, $interval) {
    "use strict";

    $scope.type = 'tm';
    $scope.id = $state.params.filter;

    $scope.model = {};
    $scope.error = {};
    $scope.page = {
        title: '',
        subTitle: ''
    };
    $scope.pop = function(type, title, text) {
        toaster.pop(type, title, text, 0, 'trustedHtml');
    };

    $scope.initialized = false;
    $scope.watchActivated = false;
    $scope.init = function(){

    	if($rootScope.user.id&&( $scope.id != 'undefined')){

            if($state.params.action=='send'){
                D.load('account', $scope.id, { cache: false }).then(function(response){
                    $scope.recipient = response
                    $scope.page.title = 'labels.SENDTM';
                    $scope.page.subTitle = '';

                    $scope.sendForm = {
                        title: 'labels.SENDTM',
                        status: '',
                        type: 'tm',
                        model: { id: $scope.recipient.id, action: 'sendZippedTMs', recipient: $scope.recipient.id },
                        fields: [
                                    {
                                        available: true,
                                        type: 'file',
                                        name: 'zipped',
                                        label: 'fields.ZIPPEDTMS',
                                        limit: -1,
                                        canUpload: true,
                                        bucket: $rootScope.bucketName(''),
                                        filesSelectable: $rootScope.user.admin,
                                        selectionActions: [
                                            { icon: 'aqi-action-delete', label: 'labels.DELETE', action: 'delete' }
                                        ] 
                                    },{
                                        available: true,
                                        type: 'submit',
                                        name: 'empty',
                                        label: 'labels.SEND'
                                    }
                                 ],
                        submit: function(){
                            $scope.sendForm.status = 'submitting';
                            D.save('tm', this.model).then(function(response){
                                $scope.sendForm.status = 'notsubmittable';
                                $scope.sendForm.successLabel = 'labels.ZIPPEDTMSENT';
                            }).catch(function(){
                                $scope.sendForm.status = 'error';
                            });
                        }
                    }

                }).catch(console.error);
                
                return
            }

            $scope.form = {}
            $scope.setForm = function(f, a) {
                $scope.noForm = { title: $scope.form.title }
                if(!a || !a.currentTarget.classList.contains('action-disabled')){
                    $scope.form = $scope[f]
                }
            } 

            D.load('tm', $scope.id, { cache: false }).then(function(model){
                $scope.tm = model;
                $scope.page = {
                    title: model.name,
                    subTitle: ''
                };

                $scope.tm.processing = false
                FIREBASE.listen('TM', model.id, function(data){
                    if(data!=null) $timeout(function(){
                        $scope.rt = data
                        //console.log('TM',data)
                        let previousProcessing = $scope.tm.processing
                        $scope.tm.processing = data.running && !data.completed
                        if(!$scope.tm.processing && previousProcessing){
                            $state.go('app.entity', { type: 'tm', action: 'lookup', filter: $scope.tm.id }, { reload: true });
                        }
                        if(data.status) $scope.tm.status = data.status
                        if(data.status=='PARSING'){
                            $scope.tm.numEntries = data.processed
                        }
                    },10)
                })
                $scope.stop = $interval(function () { 
                    if($scope.rt && $scope.rt.timestamp) $scope.lateUpdate = $scope.rt.timestamp < Date.now() - 30000;
                }, 5000)

                $scope.refreshProcessing = function(){
                    D.save('tm', { id: $scope.tm.id, action: $scope.rt.action + 'Check', fromRefresh: true })
                }

                if($state.params.action=='entries'){
                    $scope.entriesTable = {
                        type: 'dataobject',
                        baseFilter: 'entityid=' + $scope.tm.id + '&entitytype=tm',
                        includedFields: [],
                        fields: [
                            {
                                available: true,
                                name: 'source'
                            },{
                                available: true,
                                name: 'target'
                            }
                        ]
                    }
                }

                if($state.params.action=='log'){
                    $scope.loadLog = function(){
                    	D.query('actionlog','entity=' + $scope.tm.id +'').then(
                                function(response){
                                	$scope.timelineAlt = true;
                                	$scope.elements = [];
                                	for(var i=0; i<response.length; i++){
                                		var e = response[i];
                                		var data = angular.fromJson(e.data);

                                		$scope.elements.push({
                                			datetime: e.T,
                                			action: e.action,
                                			title: $filter('translate')('enums.useraction.'+e.action),
                                			content: $filter('translate')('enums.useraction.'+e.action+'_TEXT', angular.fromJson(e.data)),
                                			data: data
                                		});
                                	}
                                }
                            ).catch(console.error);
                    };
                    $scope.loadLog();
                }


                $scope.downloadForm = {
                        title: 'labels.DOWNLOADTM',
                        status: '',
                        type: 'tm',
                        model: $scope.tm,
                        fields: [
                                    {
                                        available: true,
                                        type: 'file',
                                        name: 'file',
                                        canUpload: false,
                                        cantDelete: true,
                                        showDate: true,
                                        hideIcon: true,
                                        noLabel: true,
                                        inputColumn: 12,
                                        labelColumn: 0,
                                        limit: -1,
                                        allow: '',
                                        bucket: $rootScope.bucketName($scope.tm.aqrateClient)
                                    }
                                 ],
                                 submit: function(){

                                 }
                };

                $scope.othersForm = {
                        title: 'labels.DOWNLOADOTHERS',
                        status: '',
                        type: 'tm',
                        model: $scope.tm,
                        fields: [
                                    {
                                        available: true,
                                        type: 'file',
                                        name: 'others',
                                        canUpload: $rootScope.user.group.type=='ADMIN',
                                        cantDelete: $rootScope.user.group.type!='ADMIN',
                                        showDate: true,
                                        hideIcon: true,
                                        noLabel: true,
                                        inputColumn: 12,
                                        labelColumn: 0,
                                        limit: -1,
                                        allow: '',
                                        bucket: $rootScope.bucketName($scope.tm.aqrateClient)
                                    }
                                 ],
                                 submit: function(){

                                 }
                };

                $scope.updateForm = {
                        title: 'labels.UPDATETMX',
                        status: '',
                        type: 'tm',
                        model: $scope.tm,
                        fields: [
                                    {
                                        available: $rootScope.user.group.type=='ADMIN',
                                        type: 'submit',
                                        name: 'empty',
                                        label: 'labels.UPDATETMX'
                                    }
                                 ],
                                 submit: function(){
                                     $scope.tm.action = 'startDownload';
                                     $scope.fileTimestamp = $scope.tm.T;
                                     D.save('tm', $scope.tm).then(function(response){
                                         $scope.downloadForm.status = 'notsubmittable';

                                     }).catch(console.error);
                                 }
                };

                $scope.visibleForm = {
                        title: 'labels.SETVISIBLE',
                        status: '',
                        type: 'tm',
                        model: $scope.tm,
                        fields: [
                                    {
                                        available: $rootScope.user.group.type=='ADMIN',
                                        type: 'checkbox',
                                        name: 'visible'
                                    },
                                    {
                                        available: $rootScope.user.group.type=='ADMIN',
                                        type: 'submit',
                                        name: 'empty'
                                    }
                                 ],
                                 submit: function(){
                                     $scope.tm.action = 'editVisible';
                                     D.save('tm', $scope.tm).then(function(response){
                                         $scope.visibleForm.status = 'submitted';
                                     }).catch(console.error);
                                 }
                };

                $scope.manageableForm = {
                        title: 'labels.SETMANAGEABLE',
                        status: '',
                        type: 'tm',
                        model: $scope.tm,
                        fields: [
                                    {
                                        available: $rootScope.user.group.type=='ADMIN',
                                        type: 'checkbox',
                                        name: 'manageable'
                                    },
                                    {
                                        available: $rootScope.user.group.type=='ADMIN',
                                        type: 'submit',
                                        name: 'empty'
                                    }
                                 ],
                                 submit: function(){
                                     $scope.tm.action = 'editManageable';
                                     D.save('tm', $scope.tm).then(function(response){
                                         $scope.manageableForm.status = 'submitted';
                                     }).catch(console.error);
                                 }
                };

                $scope.importForm = {
                    title: 'labels.IMPORTTMX',
                    status: '',
                    type: 'tm',
                    model: $scope.tm,
                    fields: [
                                {
                                    available: $rootScope.user.group.type=='ADMIN',
                                    type: 'submit',
                                    name: 'empty'
                                }
                             ],
                             submit: function(){
                                 $scope.tm.action = 'TmxParseImport';
                                 $scope.importForm.status = 'submitting';
                                 D.save('tm', $scope.tm).then(function(response){
                                     $scope.setForm('noForm');
                                     $scope.importForm.status = '';
                                 }).catch(console.error);
                             }
                };

                $scope.countTermsForm = {
                    title: 'labels.COUNTTERMS',
                    status: '',
                    type: 'tm',
                    model: $scope.tm,
                    fields: [{
                                available: true,
                                type: 'file',
                                name: 'termscount',
                                canUpload: true,
                                showDate: true,
                                hideIcon: true,
                                noLabel: true,
                                inputColumn: 12,
                                labelColumn: 0,
                                limit: 1,
                                allow: 'xlsx',
                                bucket: $rootScope.bucketName($scope.tm.aqrateClient)
                            },{
                                available: true,
                                type: 'checkbox',
                                name: 'hasHeader'
                            },
                            {
                                available: $rootScope.user.group.type=='ADMIN',
                                type: 'submit',
                                name: 'empty'
                            }
                             ],
                    submit: function(){
                        $scope.tm.action = 'TmxCountTerms';
                        $scope.countTermsForm.status = 'submitting';
                        D.save('tm', $scope.tm).then(function(response){
                            $scope.setForm('noForm');
                            $scope.countTermsForm.status = '';
                        }).catch(console.error);
                    }
                };

                $scope.deleteForm = {
                    title: 'labels.DELETE',
                    status: '',
                    type: 'tm',
                    model: $scope.tm,
                    fields: [
                                {
                                    available: $rootScope.user.group.type=='ADMIN',
                                    type: 'submit',
                                    name: 'empty'
                                }
                             ],
                             submit: function(){
                                
                                 ngDialog.openConfirm({
                                    template: '/app/views/entities/confirm.html',
                                    className: 'ngdialog-theme-default',
                                    scope: $scope
                                  }).then(function (value) {
                                    $scope.deleteForm.status = 'submitting';
                                        D.remove('tm', $scope.tm.id).then(function(response){
                                            $state.go('app.entity', { type: 'group', action: 'memories', filter: '_uploaded' });
                                        })
                                  })
                             }
                };

                $scope.lookupForm = {
                        title: 'labels.LOOKUPSEGMENT',
                        status: '',
                        type: 'tm',
                        model: $scope.tm,
                        fields: [
                                    {
                                        available: true,
                                        type: 'text',
                                        name: 'segment'
                                    },{
                                        available: true,
                                        type: 'checkbox',
                                        name: 'reverse'
                                    },{
                                        available: true,
                                        type: 'separator'
                                    },{
                                        available: true,
                                        type: 'submit',
                                        name: 'empty',
                                        value: 'labels.LOOKUPSEGMENT'
                                    }
                                 ],
                                 submit: function(){
                                    $scope.tm.action = 'concordance';
                                    $scope.lookupForm.status = 'submitting';
                                    $scope.lookupTable.loading = true;
                                    $scope.lookupTable.availableFields = $scope.lookupTable.fields.filter(function(e){ return e.available; });
                                    $scope.lookupTable.highlight = $scope.tm.segment;
                                    D.save('tm', $scope.tm).then(function(response){
                                        var lookupData = [];
                                        $scope.lookupTable.title = $filter('translate')('labels.LOOKUPRESULT')
                                        var result = JSON.parse(response.lookupResult).ConcResult;
                                        if(result){
                                            $scope.lookupTable.title = $filter('translate')('labels.LOOKUPRESULT') + ': ' + result.length
                                            for(var i=0; i<result.length; i++){
                                                var r = result[i];
                                                //if(!$scope.tm.reverse){
                                                //    r.TMEntry.SourceSegment = r.TMEntry.SourceSegment.replace($scope.tm.segment, '<span style="background-color: #f1cd50"><b>'+$scope.tm.segment+'</b></span>')
                                                //}
                                                lookupData.push(r.TMEntry);
                                            }
                                        }
                                        $scope.lookupData = lookupData;
                                        $scope.lookupForm.status = '';
                                        $scope.lookupTable.loading = false;
                                        $scope.lookupTable.finished = true;
                                        $scope.lookupTable.elementsLoaded = lookupData.length;
                                    }).catch(function(){
                                        $scope.lookupForm.status = 'error';
                                        $scope.lookupTable.loading = false;
                                        $scope.lookupTable.finished = true;
                                    });
                                 }
                };

                $scope.lookupTable = {
                    title: 'labels.LOOKUPRESULT',
                    fields: [
                        {
                            available: true,
                            name: 'EntryId',
                            type: 'text'
                        },{
                            available: true,
                            name: 'empty',
                            type: 'click',
                            icon: 'aqi-action-expand',
                            toggledIcon: 'aqi-action-contract',
                            iconTooltip: 'labels.VIEWCONTEXT',
                            onclick: function(model){
                                $scope.tm.action = 'getEntry';
                                $scope.tm.sourceSegment = model.EntryId;
                                model.SourceSegment = '<i class="aqi-action-loading"></i>'
                                D.save('tm', $scope.tm).then(function(response){
                                    var segment = JSON.parse(response.lookupResult)
                                    for(var i=0; i<$scope.lookupData.length; i++){
                                        if($scope.lookupData[i].EntryId==model.EntryId){
                                            if(!$scope.lookupData[i]._clickStatusToggled){
                                                $scope.lookupData[i]._clickStatusToggled = true
                                                $scope.lookupData[i].SourceSegment = ('<div class="tmEntryRelatedSegment">' + segment.PrecedingSegment + '</div>' + segment.SourceSegment + '<div class="tmEntryRelatedSegment">' + segment.FollowingSegment + '</div>').replace('<seg>','').replace('</seg>','')
                                            } else {
                                                $scope.lookupData[i]._clickStatusToggled = false
                                                $scope.lookupData[i].SourceSegment = (segment.SourceSegment).replace('<seg>','').replace('</seg>','')
                                            }
                                        }
                                    }
                                }).catch(console.error)
                            }
                        },
                        {
                            available: true,
                            name: 'SourceSegment',
                            type: 'html'
                        },{
                            available: true,
                            name: 'TargetSegment',
                            type: 'html'
                        },{
                            available: $rootScope.user.opts.writememories,
                            name: 'empty',
                            type: 'click',
                            icon: 'aqi-action-edit',
                            onclick: function(model){
                                $scope.tm.action = 'getEntry';
                                $scope.tm.sourceSegment = model.EntryId;
                                D.save('tm', $scope.tm).then(function(response){
                                    var segment = JSON.parse(response.lookupResult)
                                    
                                    $scope.tm.editSourceSegment = segment.SourceSegment.replace('<seg>','').replace('</seg>','');
                                    $scope.tm.editTargetSegment = segment.TargetSegment.replace('<seg>','').replace('</seg>','');
                                    $scope.tm.oldSourceSegment = segment.SourceSegment.replace('<seg>','').replace('</seg>','');
                                    $scope.tm.oldTargetSegment = segment.TargetSegment.replace('<seg>','').replace('</seg>','');
                                    $scope.tm.editModified = segment.Modified;
                                    $scope.tm.editEntryId = segment.Key;
                                    $scope.tm.customMetas = segment.CustomMetas;
                                    $scope.tmEditForm.status = '';
                                    ngDialog.open({
            	                	      template: '/app/views/entities/tm-edit.html',
            	                	      className: 'ngdialog-theme-large',
            	                	      scope: $scope,
            	                	      cache: false
                                      });
                                }).catch(console.error);
                            }

                        }
                    ]
                }


                $scope.tmEditForm = {
                    title: 'labels.TMEDIT',
                    status: '',
                    type: 'tm',
                    model: $scope.tm,
                    fields: [
                        {
                            available: true,
                            name: 'editSourceSegment',
                            type: 'textarea'
                        },{
                            available: true,
                            name: 'editTargetSegment',
                            type: 'textarea'
                        },{
                            available: true,
                            type: 'submit'
                        }
                    ],
                    submit: function(){
                        $scope.tm.action = 'edit';
                        $scope.tmEditForm.status = 'submitting';
                        D.save('tm', $scope.tm).then(function(response){
                            $scope.tmEditForm.status = '';
                            ngDialog.close();
                            $scope.lookupForm.submit();
                        }).catch(function(){
                            $scope.tmEditForm.status = 'error';
                        });
                    }
                }


            }).catch(console.error);

    	} else {
            if(!$scope.watchActivated){
                $scope.watchActivated = true;
                $rootScope.$watch('user.id', function(){
                    if(!$scope.initialized){
                        $scope.init();
                    }
                });
            }
        }
    }

    $scope.init();

    $scope.$on('$destroy', function() {
        if($scope.stop) $interval.cancel($scope.stop);
    });
  }
  ]);
